import { render, staticRenderFns } from "./AttractionDataFormComponent.vue?vue&type=template&id=51a104ed&scoped=true&xmlns=true&"
import script from "./AttractionDataFormComponent.vue?vue&type=script&lang=js&"
export * from "./AttractionDataFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./AttractionDataFormComponent.vue?vue&type=style&index=0&id=51a104ed&scoped=true&lang=css&"
import style1 from "./AttractionDataFormComponent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a104ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a104ed')) {
      api.createRecord('51a104ed', component.options)
    } else {
      api.reload('51a104ed', component.options)
    }
    module.hot.accept("./AttractionDataFormComponent.vue?vue&type=template&id=51a104ed&scoped=true&xmlns=true&", function () {
      api.rerender('51a104ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-event/basic-data/forms/attraction-data-form/AttractionDataFormComponent.vue"
export default component.exports